<template>
  <vx-card title="Purchased Info">
  <div>
    <div v-if="!purchasedKit">No Purchased kit</div>
    <div v-else>
      <vs-table data="_">
        <vs-tr>
          <vs-td>Order Number:</vs-td>
          <vs-td>{{ purchasedKit.orderNumber }}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Order Date:</vs-td>
          <vs-td>{{ purchasedKit.orderDate }}</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Shipstation Order Id:</vs-td>
          <vs-td>{{ purchasedKit.shipStationOrderId }}</vs-td>
        </vs-tr>
      </vs-table>
      <vs-collapse type="border" class="mt-2 mb-6" >
        <vs-collapse-item >
          <div slot="header" >
            Customer Info
          </div>
          <vs-table data="___" v-if="purchasedKit.shipTo">
            <vs-tr>
              <vs-td>Name:</vs-td>
              <vs-td>{{purchasedKit.shipTo.name || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Email:</vs-td>
              <vs-td>{{purchasedKit.shipTo.email || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Phone:</vs-td>
              <vs-td>{{purchasedKit.shipTo.phone || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Country:</vs-td>
              <vs-td>{{purchasedKit.shipTo.country || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>State:</vs-td>
              <vs-td>{{purchasedKit.shipTo.state || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>City:</vs-td>
              <vs-td>{{purchasedKit.shipTo.city || ""}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Street 1:</vs-td>
              <vs-td>{{purchasedKit.shipTo.street1}}</vs-td>
            </vs-tr>
            <vs-tr v-if="purchasedKit.shipTo.street2">
              <vs-td>Street 2:</vs-td>
              <vs-td>{{purchasedKit.shipTo.street2}}</vs-td>
            </vs-tr>
            <vs-tr v-if="purchasedKit.shipTo.street3">
              <vs-td>Street 3:</vs-td>
              <vs-td>{{purchasedKit.shipTo.street3}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td>Postal Code:</vs-td>
              <vs-td>{{purchasedKit.shipTo.postalCode || ""}}</vs-td>
            </vs-tr>
          </vs-table>
          <div v-else>No Customer Data</div>
        </vs-collapse-item>
      </vs-collapse>
      <vs-collapse type="border" class="mt-2 mb-6" v-if="showKits">
        <vs-collapse-item>
          <div slot="header" >
            DNA Kits
          </div>
          <vs-table v-if="purchasedKit.dnaKits" data="_">
            <vs-tr v-for="(kitId, index) in purchasedKit.dnaKits" :key="`kitId-${index}`">
              <vs-td>Kit Id:</vs-td>
              <vs-td>{{kitId}}</vs-td>
            </vs-tr>
          </vs-table>
        </vs-collapse-item>
      </vs-collapse>
    </div>
  </div>
  </vx-card>
</template>

<script>

export default {
  props: ["purchasedKit", "showKits"],
};
</script>
